export const parseDate = (raw: string | null | undefined): Date | undefined => {
	if (!raw) return undefined;
	const date = new Date(raw);
	return Number.isNaN(date.getTime()) ? undefined : date;
};
